var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9C3C5",
    d: "M6.58.22h4.195L6.94 16.334c2.277.57 3.835 2.4 3.835 4.685 0 2.742-2.157 4.799-4.913 4.799-2.996 0-5.034-2.171-5.034-4.8 0-1.6.24-2.742 1.079-5.256zm18.696 16.113c2.277.57 3.835 2.4 3.835 4.685 0 2.742-2.157 4.799-4.913 4.799-2.996 0-5.034-2.171-5.034-4.8 0-1.6.24-2.742 1.079-5.256L24.917.221h4.194z"
  })));
};
export default SvgQuote;